"use strict"; //================================================================ 

/** @module std */
//================================================================
// <special_math>
//
// @reference http://en.cppreference.com/w/cpp/numeric/special_math
// @author Jeongho Nam <http://samchon.org>

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./beta"));

__export(require("./gamma"));

__export(require("./bessels"));

__export(require("./ellints"));

__export(require("./expint"));

__export(require("./hermite"));

__export(require("./legendres"));

__export(require("./laguerres"));

__export(require("./zeta"));